module.exports = __webpack_public_path__ + "img/scanner1.9ed26f15.png";